import type { AttributionApi, CampaignParams } from './AttributionApi'

export class MockAttributionApi implements AttributionApi {
  async getAttributionParams(): Promise<CampaignParams | null> {
    return {
      utm_source: 'mock_source',
      utm_medium: 'mock_medium',
      utm_campaign: 'mock_campaign',
      utm_content: null,
      utm_term: null,
      fbclid: null,
      gclid: null,
    }
  }
}
